import { render, staticRenderFns } from "./Carousel3dCoverflowEffect.vue?vue&type=template&id=aa216b4a&scoped=true&"
import script from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js&"
export * from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js&"
import style0 from "./Carousel3dCoverflowEffect.vue?vue&type=style&index=0&id=aa216b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa216b4a",
  null
  
)

export default component.exports